import Colors from "../AppColors"

export const ConsultationStatusTitle = {
    'Payment pending': 'Please pay to proceed with your case',
    'Unassigned': 'Case Submitted Successfully',
    'Pending': 'Your case is under review',
    'Ongoing': 'Doctor will call you till',
    'Consulted': 'View Prescription',
    'Refunded': 'Money refunded to your Aayu wallet',
    'Visit in person': 'Visit Required',
    'Unattended': 'Unattended',
    'Cancelled': 'Cancelled',
}

export const ConsultationStatusColor = {
    'Payment pending': Colors.orange.activityStatus,
    'Unassigned': Colors.green.primary,
    'Pending': Colors.green.primary,
    'Ongoing': 'black',
    'Consulted': 'white',
    'Refunded': Colors.primary,
    'Visit in person': Colors.primary,
    'Unattended': Colors.primary,
    'Cancelled': Colors.primary,
}